<template>

    <header class="fuid-header">

        <b-container class="container-redo">

            <b-row class="fuid-langsitcher_container">

                <b-col class="d-flex justify-content-center fuid-header__logo">

                    <FundacionLogo class="fuid-logo__svg" />
                    
                </b-col>

                <b-col class="fuid-langsitcher">

                    <langSwitcher />

                </b-col>
            
            </b-row>
            
        </b-container>

    </header>

</template>

<script>

    import FundacionLogo from '@/assets/svg/fundacion-idiomas-fundazioa.svg'
    import langSwitcher from '@/components/langSwitcher.vue'

    export default {
        
        components: {

            FundacionLogo,
            langSwitcher

        }

    }
    
</script>

<style lang="scss">
    @import '@/assets/scss/_layout';
</style>